import Icon from '../components/Icon';

const Clear = Icon(
  'clear',
  <>
    <path
      fillRule="evenodd"
      d="M12 1.25c5.937 0 10.75 4.813 10.75 10.75S17.937 22.75 12 22.75 1.25 17.937 1.25 12 6.063 1.25 12 1.25m3.637 7.113a.9.9 0 0 0-1.274 0L12 10.727 9.637 8.363a.9.9 0 0 0-1.274 1.274L10.727 12l-2.364 2.363a.9.9 0 0 0 1.274 1.274L12 13.273l2.363 2.364a.9.9 0 0 0 1.274-1.274L13.273 12l2.364-2.363a.9.9 0 0 0 0-1.274"
      clipRule="evenodd"
    />
  </>
);

export default Clear;
